import {tabStatus, setSession, getSession} from '../../utils/config'
let TabStatus = {
  state: {
    status: {
      homeTopTab: null
    }
  },
  mutations: {
    sethomeTopTab (state, status) {
      setSession(tabStatus, {homeTopTab: status})
      state.status = {homeTopTab: status}
    },
    resetTabStatus (state) {
      setSession(tabStatus, {homeTopTab: null})
      state.status = {homeTopTab: null}
    }
  },
  getters: {
    gethomeTopTab (state) {
      if (!state.status.homeTopTab && state.status.homeTopTab !== 0) {
        state.status = getSession(tabStatus)
      }
      return state.status.homeTopTab
    }
  }
}

export default TabStatus



// WEBPACK FOOTER //
// ./src/store/modules/tabStatus.js